'use client';
import HeroBanner from '@/components/home/HeroBanner';
import PopularOffers from '@/components/home/PopularOffers';
import PopularStores from '@/components/home/PopularStores';
import TopCoupons from '@/components/home/TopCoupons';
import DealsOfTheDay from '@/components/home/DealsOfTheDay';
import Collections from '@/components/home/Collections';
import LazySection from '@/components/common/LazySection';

export default function HomeClient({ initialBanners = [] }: { initialBanners?: any[] }) {
  return (
    <main>
      {/* SEO: primary page heading. Visually hidden (sr-only) so it does not alter
          the visible layout, but is read by search engines and screen readers. */}
      <h1 className="sr-only">Save on Every Purchase with Verified Coupons &amp; Deals</h1>
      <HeroBanner initialBanners={initialBanners} />
      <LazySection skeleton="cards"><PopularOffers /></LazySection>
      <LazySection skeleton="stores"><PopularStores /></LazySection>
      <LazySection skeleton="coupons"><TopCoupons /></LazySection>
      <LazySection skeleton="cards"><DealsOfTheDay /></LazySection>
      <LazySection skeleton="cards"><Collections /></LazySection>
    </main>
  );
}
